import React from 'react';
import Icon from '../../../components/AppIcon';

const MIN_HORIZON = 1;
const MAX_HORIZON = 60;

const PlanningHorizonControls = ({
  currentYear,
  horizonYears,
  deathYear,
  onHorizonChange,
  onDeathYearChange,
  compact = false,
}) => {
  const maxDeathYear = currentYear + Math.max(MIN_HORIZON, parseInt(horizonYears, 10) || MIN_HORIZON);

  const handleHorizon = (raw) => {
    const n = parseInt(raw, 10);
    if (!Number.isFinite(n)) return;
    onHorizonChange(Math.min(MAX_HORIZON, Math.max(MIN_HORIZON, n)));
  };

  const handleDeath = (raw) => {
    const n = parseInt(raw, 10);
    if (!Number.isFinite(n)) return;
    onDeathYearChange(Math.min(maxDeathYear, Math.max(currentYear, n)));
  };

  return (
    <div
      className={`rounded-xl border border-border bg-card ${compact ? 'p-3' : 'p-4 md:p-5'}`}
      data-testid="planning-horizon-controls"
    >
      <div className={`flex flex-col ${compact ? 'gap-3' : 'sm:flex-row sm:items-end gap-4'}`}>
        <div className="flex items-center gap-2 shrink-0">
          <Icon name="CalendarRange" size={18} className="text-primary" />
          <div>
            <p className="text-sm font-semibold text-foreground">Paramètres de projection</p>
            {!compact && (
              <p className="text-xs text-muted-foreground">Horizon et année du scénario au décès</p>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 flex-1 max-w-xl">
          <div>
            <label htmlFor="planning-horizon-years" className="block text-xs text-muted-foreground mb-1">
              Années de projection
            </label>
            <input
              id="planning-horizon-years"
              type="number"
              min={MIN_HORIZON}
              max={MAX_HORIZON}
              step={1}
              value={horizonYears}
              onChange={(e) => handleHorizon(e.target.value)}
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
              data-testid="planning-horizon-years-input"
            />
            <p className="text-[10px] text-muted-foreground mt-0.5">
              {currentYear} → {currentYear + (parseInt(horizonYears, 10) || 0)}
            </p>
          </div>

          <div>
            <label htmlFor="planning-death-year" className="block text-xs text-muted-foreground mb-1">
              Année décès simulé
            </label>
            <input
              id="planning-death-year"
              type="number"
              min={currentYear}
              max={maxDeathYear}
              step={1}
              value={deathYear}
              onChange={(e) => handleDeath(e.target.value)}
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
              data-testid="planning-death-year-input"
            />
            <p className="text-[10px] text-muted-foreground mt-0.5">
              Entre {currentYear} et {maxDeathYear}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningHorizonControls;
